import {
    Environment,
    Network,
    RecordSource,
    Store,
    FetchFunction,
    Observable,
    RelayFeatureFlags
} from "relay-runtime";

RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;

// NOTE: We extract `RecordMap` type from `RecordSource` constructor
// because it is not exported from `relay-runtime`, but we need it
// to pass initial records to the store with type safety.
export type RecordMap = NonNullable<
    ConstructorParameters<typeof RecordSource>[0]
>;

// TODO: Lift this into environment
const GATEWAY_URL =
    process.env["NODE_ENV"] === "production"
        ? "https://www.atlassian.com/gateway/api/graphql"
        : "https://wac.stg.internal.atlassian.com/gateway/api/graphql";

function createRelayEnvironment(
    initialRecords?: RecordMap,
    baseUrlOverride?: string,
    authToken?: string
) {
    const baseUrl = baseUrlOverride ?? GATEWAY_URL;

    let headers = { "Content-Type": "application/json" };
    if (authToken) {
        headers = Object.assign({}, headers, {
            Authorization: `Bearer ${authToken}`
        });
    }

    const fetchResponse: FetchFunction = (params, variables) => {
        const response = fetch(baseUrl, {
            method: "POST",
            headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({ query: params.text, variables })
        });
        return Observable.from(response.then((data) => data.json()));
    };

    const network = Network.create(fetchResponse);
    const store = new Store(new RecordSource(initialRecords));
    return new Environment({ network, store });
}

let clientSideRelayEnvironment: Environment | undefined;

export function initRelayEnvironment(
    initialRecords?: RecordMap,
    baseUrlOverride?: string,
    authToken?: string
) {
    const environment =
        clientSideRelayEnvironment ??
        createRelayEnvironment(initialRecords, baseUrlOverride, authToken);

    if (typeof window === "undefined") {
        return environment;
    }

    if (!clientSideRelayEnvironment) {
        clientSideRelayEnvironment = environment;
    } else if (initialRecords) {
        environment.getStore().publish(new RecordSource(initialRecords));
    }

    return clientSideRelayEnvironment;
}
